export type DeviceType = "ios" | "android" | "desktop";

export const IOS_STORE_URL = "https://apps.apple.com/au/app/fam/id6748098832";
export const ANDROID_STORE_URL =
  "https://play.google.com/store/apps/details?id=life.fam.fam_app&pcampaignid=web_share";

export const IOS_STORE_URL_STAGING = "https://apps.apple.com/au/app/fam/id6759595965";
export const ANDROID_STORE_URL_STAGING =
  "https://play.google.com/apps/internaltest/4700871654548717057";

export const SIGNIN_ANDROID_REFERRER =
  "utm_source=website&utm_medium=signin_landing&utm_campaign=update_required";

export const detectDevice = (): DeviceType => {
  const userAgent =
    navigator.userAgent || navigator.vendor || (window as Window & { opera?: string }).opera || "";

  if (/iPad|iPhone|iPod/.test(userAgent) && !(window as Window & { MSStream?: unknown }).MSStream) {
    return "ios";
  }

  if (/android/i.test(userAgent)) {
    return "android";
  }

  return "desktop";
};

export const isStagingPath = (pathname: string): boolean =>
  pathname.startsWith("/staging/");

export const getStoreUrls = (pathname: string) => {
  const staging = isStagingPath(pathname);
  return {
    ios: staging ? IOS_STORE_URL_STAGING : IOS_STORE_URL,
    android: staging ? ANDROID_STORE_URL_STAGING : ANDROID_STORE_URL,
    staging,
  };
};

export const getAndroidStoreUrlWithReferrer = (
  androidStoreUrl: string,
  referrer: string,
  staging: boolean
): string => {
  if (staging) {
    return androidStoreUrl;
  }
  return `${androidStoreUrl}&referrer=${encodeURIComponent(referrer)}`;
};
